import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { IUser } from '@shared/models/iuser.model';
import { UserInfoResolver } from '@shared/resolvers/user-info.resolver';
import { LookupRefService } from '@shared/services/lookup-ref.service';
import { UserService } from '@user/services/user.service';
import { forkJoin, Observable, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

@Injectable()
export class InactiveGuardService {
  constructor(
    private lookupRefService: LookupRefService,
    private router: Router,
    private userService: UserService,
    private userInfoResolver: UserInfoResolver
  ) {}

  canActivateChild(): Observable<boolean> | Promise<boolean> | boolean {
    return this.canActivate();
  }

  canActivate(): Observable<boolean> | Promise<boolean> {
    return forkJoin([this.user$, this.activeStatu$]).pipe(switchMap(this.compareIfUserIsNotActive.bind(this)));
  }

  private compareIfUserIsNotActive([user, activeStatus]: any) {
    const { id, statusId } = user;
    return of(!!id && statusId === activeStatus.key ? this.router.parseUrl('') : true);
  }

  private get user$(): Observable<IUser> {
    const localUser = this.userInfoResolver.resolve();
    const { id } = localUser;
    return !!id ? this.userService.getUsers(id) : of(localUser);
  }

  private get activeStatu$() {
    const valueToLowerCase = ({ value = '', ...status }) => ({ ...status, value: value.toLowerCase() });
    const byActiveState = ({ value }) => 'active' === value;

    const valueAndFindActiveState = statuses => statuses.map(valueToLowerCase).find(byActiveState);

    return this.lookupRefService.getUserStatuses().pipe(map(valueAndFindActiveState));
  }
}
